function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.98,437.02c-99.974-99.975-99.974-262.065,0-362.04C74.973,74.991,222.609,256,222.609,256L74.98,437.02z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgZar = function SvgZar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), _ref2, React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M222.609,256L33.953,128.513c-5.849,10.167-11.007,20.779-15.439,31.763l95.509,95.725l-95.506,95.73 c4.428,10.976,9.581,21.581,15.426,31.741L222.609,256z"
  }), React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M509.833,222.609H222.602L74.978,74.984c-15.908,15.908-29.729,33.899-41.025,53.53L161.192,256 L33.943,383.47c11.296,19.636,25.123,37.633,41.035,53.545l147.624-147.624h287.231C511.256,278.461,512,267.317,512,256 C512,244.683,511.256,233.539,509.833,222.609z"
  }), React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M100.138,459.077C143.307,492.259,197.344,512,256,512c118.279,0,217.805-80.221,247.181-189.217 H236.433L100.138,459.077z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M503.181,189.217C473.805,80.221,374.279,0,256,0c-58.656,0-112.693,19.741-155.862,52.923 l136.294,136.294H503.181z"
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ZAR.81a39a30.svg";
export { ForwardRef as ReactComponent };